(() => {
  'use strict';
  let referralEmittedInPage = false;

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (_) {
      return false;
    }
  };

  const push = (eventName, detail = {}) => {
    if (!analyticsAllowed()) return false;
    if (!Array.isArray(window.dataLayer)) return false;
    window.dataLayer.push({
      event: eventName,
      one_luxury_candidate: 'whole_site_agentic_upgrade_2026_08_29',
      ...detail,
    });
    return true;
  };

  const explicitReferralSource = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const source = (params.get('utm_source') || '').toLowerCase();
      if (['copilot', 'microsoft_copilot'].includes(source)) return 'microsoft_copilot';
      if (source === 'chatgpt') return 'chatgpt';
      if (['gemini', 'google_ai'].includes(source)) return 'google_ai';
      if (['meta_ai'].includes(source)) return 'meta_ai';

      if (!document.referrer) return null;
      const host = new URL(document.referrer).hostname.toLowerCase();
      if (host === 'copilot.microsoft.com') return 'microsoft_copilot';
      if (host === 'chatgpt.com' || host.endsWith('.chatgpt.com')) return 'chatgpt';
      if (host === 'gemini.google.com') return 'google_ai';
    } catch (_) {
      return null;
    }
    return null;
  };

  const emitReferralOnce = () => {
    if (!analyticsAllowed()) return;
    if (referralEmittedInPage) return;
    const referralSource = explicitReferralSource();
    if (!referralSource) return;
    const key = 'one_luxury_agentic_referral_emitted';
    try {
      if (window.sessionStorage.getItem(key) === '1') return;
    } catch (_) {
      return;
    }
    if (!push('agentic_referral', { agentic_source: referralSource })) return;
    referralEmittedInPage = true;
    try {
      window.sessionStorage.setItem(key, '1');
    } catch (_) {
      // The event was sent; storage failure must not send a second event now.
    }
  };

  emitReferralOnce();
  document.addEventListener('visitorConsentCollected', emitReferralOnce, { once: true });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-one-luxury-agentic-link]');
    if (!link) return;
    push('one_luxury_agentic_intent_click', {
      intent: link.dataset.intent || 'unspecified',
      destination_path: link.getAttribute('href') || '',
    });
  }, { passive: true });
})();
